import Bold from '@tiptap/extension-bold'
import BulletList from '@tiptap/extension-bullet-list'
import Color from '@tiptap/extension-color'
import Document from '@tiptap/extension-document'
import ListItem from '@tiptap/extension-list-item'
import OrderedList from '@tiptap/extension-ordered-list'
import Paragraph from '@tiptap/extension-paragraph'
import Text from '@tiptap/extension-text'
import TextAlign from '@tiptap/extension-text-align'
import TextStyle from '@tiptap/extension-text-style'

const tiptapExtensions = [
  Document,
  Text,
  TextStyle.configure({
    mergeNestedSpanStyles: true,
  }),
  Color,
  Paragraph,
  Bold,
  BulletList,
  OrderedList,
  ListItem,
  TextAlign.configure({
    types: ['paragraph'],
  }),
]

export default tiptapExtensions
